import React, { useEffect, useState } from 'react'
import { FragmentProps } from '../../../interfaces/Publication'
import parse from 'html-react-parser'

const Credits = ({fragment}: FragmentProps) => {


    const [credits, setCredits] = useState<string>("")


    useEffect(() => {

        let theCredits = fragment.text
        
        theCredits = theCredits.replaceAll("<ul", "<ul class='credits-article__list'")
        theCredits = theCredits.replaceAll("<li", "<li class='credits-article__list-item'")
        theCredits = theCredits.replaceAll("<span", "<span class='author'")

        setCredits(theCredits)
    }, [fragment])

    return (
        <section className="credits-article" aria-label="creditos">
            <h5 className="credits-article__title">Créditos</h5>
            {parse(credits)?parse(credits):null}
        </section>
    )
}

export default Credits
